import bgSpeed from '../assets/images/privacy-bg.png';
import Contact from '../components/home/Contact';

function PrivacyTerms() {
  return (
    <>
      {/* Hero Section */}
      <section className="relative h-[40vh] flex items-center justify-center text-center overflow-hidden">
        {/* Background */}
        <img
          src={bgSpeed}
          alt="Decorative background"
          className="absolute inset-0 w-full h-full object-cover"
        />
       

        {/* Heading */}
        <div className="relative z-10 px-4">
          <h1 className="special-header pt-20 text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">
            PRIVACY & TERMS OF USE
          </h1>
          <p className="max-w-2xl mx-auto text-gray-300 text-sm sm:text-base md:text-lg">
            Everything you need to know about how we collect data and how our platform works.
          </p>
        </div>
      </section>

      {/* Privacy Policy Section */}
      <section className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 lg:grid-cols-3 gap-12">
        {/* Sidebar Title */}
        <div>
          <h2 className="special-header text-3xl font-bold mb-2">PRIVACY POLICY</h2>
          <p className="text-sm text-[#F55109] font-medium">Effective Date: May 2025</p>
        </div>

        {/* Content */}
        <div className="lg:col-span-2 space-y-6 text-gray-700 leading-relaxed">
          <p>
            At Speedyssey, we take your privacy seriously. We are committed to protecting the personal information
            you share with us and being transparent about how we handle it.
          </p>
          <p>
            We may collect personal data such as your name, email address, phone number, company name, and shipping
            preferences. This information is gathered when you fill out forms on our website, request a quote,
            subscribe to updates, or contact our support team.
          </p>
          <p>We use this data solely to:</p>
          <ul className="list-disc list-inside ml-4 space-y-2">
            <li>Communicate with you</li>
            <li>Provide and improve our logistics services</li>
            <li>Respond to your inquiries and support requests</li>
            <li>Process shipping and quote information</li>
            <li>Send important service notifications or updates</li>
          </ul>
          <p>
            We do not sell, rent, or share your personal information with third parties for advertising or marketing
            purposes. All information is stored securely using trusted tools and access is strictly limited to
            authorized personnel. We take appropriate technical and organizational measures to prevent unauthorized
            access, misuse, or disclosure.
          </p>
          <p>
            Our website may use cookies to enhance your browsing experience and collect anonymous analytics data to
            improve our performance. You can disable cookies in your browser settings if you prefer.
          </p>
          <p>
            You have full control over your personal data. You may request to view, update, or delete your
            information at any time by contacting us at <a href="mailto:privacy@speedyssey.com" className="text-[#F55109] underline">privacy@speedyssey.com</a>.
          </p>
          <p>
            For any questions or concerns regarding this Privacy Policy, feel free to reach out to us.
          </p>
        </div>
      </section>

      {/* Terms & Conditions Section */}
      <section className="container mx-auto px-4 sm:px-6 lg:px-8 pb-24 grid grid-cols-1 lg:grid-cols-3 gap-12">
        {/* Sidebar Title */}
        <div>
          <h2 className="special-header text-3xl font-bold mb-2">TERMS & CONDITIONS</h2>
          <p className="text-sm text-[#F55109] font-medium">Effective Date: May 2025</p>
        </div>

        {/* Content */}
        <div className="lg:col-span-2 space-y-6 text-gray-700 leading-relaxed">
          <p>
            By using the Speedyssey website or services, you agree to the following terms:
          </p>
          <ul className="list-disc list-inside ml-4 space-y-2">
            <li>We provide this site for general information and service access. All content is owned by Speedyssey and may not be copied or reused without permission.</li>
            <li>You agree not to misuse the site or attempt to damage its functionality or security.</li>
            <li>We may update or change our services, content, or pricing at any time without prior notice.</li>
            <li>We are not responsible for external websites we link to, nor for any damages resulting from the use of this site.</li>
            <li>By submitting forms or using our tools, you confirm that the information you provide is accurate and that you have the right to share it.</li>
            <li>We may update these terms as needed. For questions, please contact us at <a href="mailto:legal@speedyssey.com" className="text-[#F55109] underline">legal@speedyssey.com</a>.</li>
          </ul>
        </div>
      </section>
      <Contact />
    </>
  );
}

export default PrivacyTerms;
